export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  // Request related
  'component.request.failed': 'Request failed!',
  'component.request.token.expired': 'Login expired, please login again',
  'component.request.no.response': 'No response from server, please retry',
  'component.request.error': 'Request error, please retry',
  'component.request.status': 'Response status: {status}',
};
